import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthGuardService } from './services/auth-guard.service';
import { AuthService } from './services/auth.service';
import { CityAutocompleteInterceptor } from './interceptors/city-autocomplete.interceptor';
import { ConfarenceMenberSelectionComponent } from './admin-dashboard/user-list/confarence_menber_selection/confarence-menber-selection/confarence-menber-selection.component';
import { CardsBooksPosterDetailsComponent } from './common-components/cards-books-poster-details/cards-books-poster-details.component';
import { BlogManagemntComponent } from './blog-managemnt/blog-managemnt.component';
import { AddBlogComponent } from './blog-managemnt/add-blog/add-blog.component';
import { CommonPreviewModalComponent } from './common-components/common-preview-modal/common-preview-modal.component';
import { AddBrodcastingComponent } from './brod-casting/add-brodcasting/add-brodcasting.component';
import { EditBrodcastingComponent } from './brod-casting/list-brodcasting/edit-brodcasting.component';
import { ContentPreviewComponent } from './common-components/content-preview/content-preview.component';
import { SuccessComponent } from './success/success.component';
import { MysterySchoolSignupComponent } from './mystery-school-signup/mystery-school-signup.component';
import { PerennialSubscriptionSuccessComponent } from './perennial-subscription-success/perennial-subscription-success.component';
import { MysterySubscriptionSuccessComponent } from './mystery-subscription-success/mystery-subscription-success.component';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AstroDecanVideoPronuncementViewComponent } from './common-components/astro-decan-video-pronuncement-view/astro-decan-video-pronuncement-view.component';
import { CustomerHeaderComponent } from './layout/customer-header/customer-header.component';
import { OrderReviewComponent } from './common-components/order-list/order-review/order-review.component';
import { IngressDetailsComponent } from './ingress-details/ingress-details.component';
import { IngresschartsComponent } from './ingresscharts/ingresscharts.component';
import { ForcePasswordChangeComponent } from './force-password-change/force-password-change.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { RefundRequestListComponent } from './common-components/refund-request-list/refund-request-list.component';
import { RefundRequestPreviewComponent } from './common-components/refund-request-list/refund-request-preview/refund-request-preview.component';
import { RefundCommentSectionComponent } from './common-components/refund-request-list/refund-comment-section/refund-comment-section.component';

import { AddVideoImageForRedundRequestComponent } from './common-components/refund-request-list/add-video-image-for-redund-request/add-video-image-for-redund-request.component';
import { RefundRequestActivityLogComponent } from './common-components/refund-request-list/refund-request-activity-log/refund-request-activity-log.component';
import { IngressChartDetailComponent } from './common-components/ingress-chart-detail/ingress-chart-detail.component';
import { IngressChartsListComponent } from './common-components/ingress-charts-list/ingress-charts-list.component';
import { IngressIconPipePipe } from './pipes/ingress-icon-pipe.pipe';
// import { ShareLinkModalComponent } from './common-components/share-link-modal/share-link-modal.component';
// import { DashboardSwitcherComponent } from './common-components/dashboard-switcher/dashboard-switcher.component';




// import { HorosceopComComponent } from './horosceop-com/horosceop-com.component';

// import { AstroHeaderComponent } from './layout/astro-header/astro-header.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    ConfarenceMenberSelectionComponent,
    CardsBooksPosterDetailsComponent,
    BlogManagemntComponent,
    AddBlogComponent,
    CommonPreviewModalComponent,
    AddBrodcastingComponent,
    EditBrodcastingComponent,
    ContentPreviewComponent,
    SuccessComponent,
    MysterySchoolSignupComponent,
    PerennialSubscriptionSuccessComponent,
    MysterySubscriptionSuccessComponent,
    AstroDecanVideoPronuncementViewComponent,
    OrderReviewComponent,
    IngressDetailsComponent,
    IngresschartsComponent,
    ForcePasswordChangeComponent,
    ChangePasswordComponent,
    RefundRequestPreviewComponent,
    RefundCommentSectionComponent,
 
    AddVideoImageForRedundRequestComponent,
      RefundRequestActivityLogComponent,
      IngressChartDetailComponent,
      IngressChartsListComponent,
      IngressIconPipePipe,
      // ShareLinkModalComponent,
    
    // DashboardSwitcherComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MatProgressBarModule,
    SharedModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    MatSelectModule,
    MatFormFieldModule,
  ],

  providers: [
    AuthGuardService,
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CityAutocompleteInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA
  ],
})
export class AppModule { }
